// Generated from src/assets/Check.svg
import React, { PureComponent } from "react";

interface ISVGDownTriangleIconProps {
  /**
   * additional classname
   */
  // prettier-ignore
  className?: string;
  /**
   * size of the svg icon
   */
  // prettier-ignore
  size?: string | number;
  /**
   * color of the svg icon
   */
  // prettier-ignore
  fill?: string;
  /**
   * onClick event
   */
  // prettier-ignore
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const style = {
  display: "block",
  flex: "0 0 auto",
  cursor: "pointer"
};

export default class SVGDownTriangleIcon extends PureComponent<
  ISVGDownTriangleIconProps,
  {}
> {
  render() {
    const props = this.props;
    const { size, fill } = props;
    return (
      <svg
        {...props}
        preserveAspectRatio="xMidYMid meet"
        fontSize={size || 32}
        fill={fill || "currentColor"}
        style={style}
        width="20"
        height="20"
        viewBox="0 0 531.74 460.5"
        overflow="visible"
        enableBackground="new 0 0 531.74 460.5"
      >
        <polygon points="530.874,0.5 265.87,459.5 0.866,0.5 " />
      </svg>
    );
  }
}
